import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/HeaderB";
import ProfileSidebar from "../components/ProfileSideBar";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";

const AdminMenu = () => {
  const navigate = useNavigate();
  const { user, language } = useContext(AuthContext);

  const translations = {
    el: {
      welcome: "Καλώς ήρθες",
      viewAll: "Διαχείριση προσφορών",
      manageStores: "Διαχείριση καταστημάτων",
      manageCategories: "Διαχείριση κατηγοριών",
      manageUsers: "Διαχείριση χρηστών",
      viewStatistics: "Στατιστικά"
    },
    en: {
      welcome: "Welcome",
      viewAll: "Manage Offers",
      manageStores: "Manage stores",
      manageCategories: "Manage categories",
      manageUsers: "Manage users",
      viewStatistics: "Dashboard"
    }
  };

  const t = translations[language] || translations.el;
  
  return (
    <div className="min-h-screen bg-custom-background flex flex-col">
      <Header /> {/* Header */}

      <main id="main-content" className="flex-1 flex flex-col items-center justify-center relative text-center px-4 md:px-8 py-10">
        <ProfileSidebar />

        {/* Main Content */}
        <h1 className="text-2xl md:text-3xl font-bold text-custom-letters mb-10">
          {t.welcome}, {user?.username || "Admin"}!
        </h1>

        <div id="menu-actions" className="flex flex-col md:flex-row gap-6 flex-wrap justify-center">
          <button
            onClick={() => navigate("/admindiscounts")}
            className="bg-gradient-to-r from-custom-grad1 via-custom-grad2 via-custom-grad3 to-custom-grad4 text-white font-semibold py-5 px-8 rounded-2xl shadow-md hover:scale-105 transition focus:outline-none focus:ring-4 focus:ring-custom-letters focus:ring-offset-2">
            {t.viewAll}
          </button>

          <button
            onClick={() => navigate("/adminstores")}
            className="bg-gradient-to-r from-custom-grad1 via-custom-grad2 via-custom-grad3 to-custom-grad4 text-white font-semibold py-5 px-8 rounded-2xl shadow-md hover:scale-105 transition focus:outline-none focus:ring-4 focus:ring-custom-letters focus:ring-offset-2">
            {t.manageStores}
          </button>

          <button
            onClick={() => navigate("/admincategories")}
            className="bg-gradient-to-r from-custom-grad1 via-custom-grad2 via-custom-grad3 to-custom-grad4 text-white font-semibold py-5 px-8 rounded-2xl shadow-md hover:scale-105 transition focus:outline-none focus:ring-4 focus:ring-custom-letters focus:ring-offset-2">
            {t.manageCategories}
          </button>

          <button
            onClick={() => navigate('/adminusers')}
            className="bg-gradient-to-r from-custom-grad1 via-custom-grad2 via-custom-grad3 to-custom-grad4 text-white font-semibold py-5 px-8 rounded-2xl shadow-md hover:scale-105 transition focus:outline-none focus:ring-4 focus:ring-custom-letters focus:ring-offset-2">
            {t.manageUsers}
          </button>

          <button
            onClick={() => navigate("/admindashboard")}
            className="bg-gradient-to-r from-custom-grad1 via-custom-grad2 via-custom-grad3 to-custom-grad4 text-white font-semibold py-5 px-8 rounded-2xl shadow-md hover:scale-105 transition focus:outline-none focus:ring-4 focus:ring-custom-letters focus:ring-offset-2">
            {t.viewStatistics}
          </button>
        </div>
      </main>
    </div>
  );
};

export default AdminMenu;
